<template>
    <div v-if="hasSummaryMetrics">
        <table class="table table-compact table-definition table-collapsed">
            <colgroup><col class="width-xxl"></colgroup>
            <tr v-for="(metric, index) in summaryMetrics" :key="index">
                <td>{{metric.label}}</td>
                <td v-fs-block>{{metric.value}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import {mapState, mapActions} from 'vuex';

    export default {
        name: 'customer-stats',
        mixins: [
            LoadStateMixin,
        ],
        computed: {
            ...mapState('customers', ['customer', 'lifetimeSummaryMetrics']),
            hasSummaryMetrics() {
                return this.summaryMetrics.length > 0;
            },
            summaryMetrics() {
                if (this.lifetimeSummaryMetrics) {
                    const {lifetimeRevenue, averageValue, lastPaymentTime} = this.customer;
                    const formatCurrency = v => this.$filters.monetizeExplicit(v, lifetimeRevenue.currency);
                    return [
                        {
                            label: 'Last Payment',
                            value: lastPaymentTime ? this.$tz().readUTC(lastPaymentTime).fromNow() : '-',
                        },
                        {
                            label: 'Lifetime Revenue',
                            value: lifetimeRevenue ? formatCurrency(lifetimeRevenue.amount) : '-',
                        },
                        {
                            label: 'Payments',
                            value: this.customer.paymentCount,
                        },
                        {
                            label: 'Average Value',
                            value: averageValue ? formatCurrency(averageValue.amount) : '-',
                        },
                    ];
                }
                return [];
            },
        },
        methods: {
            ...mapActions({
                fetchLifetimeSummaryMetrics: 'customers/fetchLifetimeSummaryMetrics',
            }),
            async fetchData() {
                try {
                    this.fetchLifetimeSummaryMetrics();
                } catch (error) {
                    this.$toast.fromError(error, 'Unable retrieve customer data. Please try again later or contact support.');
                }
            },
        },
    };
</script>
